import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';
import { QuestionExceptionConfig } from './questionException';

export interface MediaQuestionConfig
  extends WorkflowQuestionConfig,
    QuestionExceptionConfig {
  isIdpSource?: boolean;
}

export interface MediaResponseState extends WorkflowResponseState {
  mediaIds?: string[];
}
